import SharedEnvStore from '@get-bridge/learn-legacy-shared/dist/stores/SharedEnvStore';

// Because of the work on [BRD-7189](https://getbridge.atlassian.net/browse/BRD-7189),
// we split the shared code used by get_smart modules (my-learning, author, etc)
// into two new repositories:
// [learn-legacy-shared](https://github.com/get-bridge/learn-legacy-shared/) and
// [learn-legacy-packages](https://github.com/get-bridge/learn-legacy-packages/).
// They are now GH packages that get_smart and the new Learn repos will use.
// One problem resulted from this initiative is that all of the local environment
// variables we use from get_smart's env files are no longer available in these two packages.
// As a solution, we created a store in learn-legacy-shared that holds these env vars
// in execution time and makes them accessible from learn-legacy-shared and learn-legacy-packages.
// To make an env variable available for both libraries, we need to set them as follows.
//
// WARNING: If you plan to move a Learn app to Tapestry, make sure you migrate
// all the necessary .env items from get_smart to the new repo, and set up SharedEnvStore
// accordingly as done here.

SharedEnvStore.set('CDN_URL', process.env.CDN_URL);
SharedEnvStore.set('DEPLOY_ENV', process.env.DEPLOY_ENV);
SharedEnvStore.set('GGG_ENABLED', process.env.GGG_ENABLED);
SharedEnvStore.set('NODE_ENV', process.env.NODE_ENV);
SharedEnvStore.set('YOUTUBE_BROWSER_API_KEY', process.env.YOUTUBE_API_KEY);



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/setupSharedEnvStore.js